import './index.scss';

export default (props) => (
  <p className={`alert alert--${props.type} ${props.className}`} role={`${props.type}`}>
      <span className="alert-icon alert-icon-variant">    
      <span className="icon " style={{WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled.svg)", color: "currentColor"}}>
      {props.text}
    </span>
      </span>
      <span className="alert-text">{props.text}</span>
    </p>
)

/*

  <p className={`alert alert--${props.type} ${props.className}`} role={`${props.type}`}>
    <span className="alert-icon alert-icon-variant">

      <span className="icon " >
      </span>
    </span>
    <span className="alert-text">{props.text}</span>
    <span className="control">
      <button className="icon-button secondary medium" onclick="" title="Icon Button">
        <span className="icon " >
        </span>
      </button>
    </span>
  </p>*/